import { render } from "./FormDataTable.vue?vue&type=template&id=6e8ec26b&scoped=true"
import script from "./FormDataTable.vue?vue&type=script&lang=js"
export * from "./FormDataTable.vue?vue&type=script&lang=js"

import "./FormDataTable.vue?vue&type=style&index=0&id=6e8ec26b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8ec26b"]])

export default __exports__